import { useState, useEffect } from 'react';
import { useTranslate } from '@educaplay/core/hooks'
import { useSelector } from 'react-redux';
import { SCREENS } from '@educaplay/store/constants';

import classes from './ExitDialog.module.scss'
import { Button } from '@educaplay/core';
import { Dialog } from "@educaplay/core/components";
import { finishGame } from '@educaplay/store/slices/gameSlice';
import { useDispatch } from 'react-redux';

export function ExitDialog() {
    const [open, setOpen] = useState(false);
    const t = useTranslate();
    const isOpen = useSelector(state => state.settings.isOpen);
    const screen = useSelector(state => state.game.view);
    const dispatch = useDispatch();

    const closeDialog = () => {
        setOpen(false);
    }

    const abandonActivity = () => {
        setOpen(false);
        dispatch(finishGame());
    }

    useEffect(() => {
        if(screen === SCREENS.SCORE_SCREEN) return;
        
        const handleKeyDown = (event) => {
            if (event.keyCode === 27 && !isOpen) {
                setOpen(true);
            }
        }
    
        window.addEventListener('keydown', handleKeyDown);
    
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }
    
    }, [screen, isOpen]);
    
    
    return (
        <Dialog open={open} onClose={() => setOpen(false)} variant="confirm">
            <div className={classes.modal}>
            <div className={classes.modalHeader}>
                <p>{t("common.game.abandon")}</p>
            </div>
            <div className={classes.modalFooter}>
                <Button className={classes.btnCancel} onClick={closeDialog}>{t("common.settings.cancel")}</Button>
                <Button className={classes.btnAccept} onClick={abandonActivity}>{t("common.settings.accept")}</Button>
            </div>
            </div>
        </Dialog>
    )
}

export default ExitDialog

